// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/wishlist/comment.php
import Rule from 'offline/filter/core/search/rule'

export default {
	name: 'wishlist.comment',
	priority: 80,
	require: function(config, filter) { return filter.wishlist && filter.wishlist.comment && filter.wishlist.comment.length > 0 },
	run: function(config, filter, data, query) {
		var keywords = Rule.getKeywords(filter.wishlist.comment)
		for (var i = 0; i < keywords.length; i++) {
			query.where('c.collection_wishlist_comment', 'like', '%' + keywords[i] + '%')
		}
	}
}
